import store from '@/store';

export default function routerBeforeEnterOrderHistory(to, from, next) {
  const hideOrderHistory = store.getters['merchant/merchant'].features['hide-order-history'];

  if (hideOrderHistory) {
    let redirectRoute = {
      name: 'orderMenu',
      params: { merchantId: to.params.merchantId }
    };

    const { alternateLandingPage } = store.getters['merchant/merchant'].options;

    if (alternateLandingPage) {
      redirectRoute = { path: new URL(alternateLandingPage).pathname };
    }

    next(redirectRoute);
  }
  else {
    next();
  }
}
